{
  "bindings": {
    "p1-add-btn:tap": {
      "flow": "addToCart"
    },
    "p2-add-btn:tap": {
      "flow": "addToCart"
    },
    "p3-add-btn:tap": {
      "flow": "addToCart"
    },
    "p4-add-btn:tap": {
      "flow": "addToCart"
    }
  }
}
